module.exports = __webpack_public_path__ + "static/media/1.6197f2ad.jpg";